import { Component, computed, inject, LOCALE_ID, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-language',
  imports: [],
  templateUrl: './change-language.html',
  styleUrl: './change-language.scss'
})
export class ChangeLanguage {
private locale = inject(LOCALE_ID);
  private router = inject(Router);

  isAr = computed(() => this.locale.startsWith('ar'));
  loading = signal(false);
  dropdownOpen = signal(false);
  selectedLanguageId = signal<string | null>(this.locale.startsWith('ar') ? 'ar' : 'en'); 

  languages = [
    { id: 'ar', labelAr: 'العربية', labelEn: 'Arabic', flag: '🇸🇦' },
    { id: 'en', labelAr: 'الإنجليزية', labelEn: 'English', flag: '🇬🇧' },
    { id: 'fr', labelAr: 'الفرنسية', labelEn: 'French', flag: '🇫🇷' },
  ];

  selectedLanguageItem = computed(() => this.languages.find(lang => lang.id === this.selectedLanguageId()) || null);

  ngOnInit() {
  }

  toggleDropdown() {
    this.dropdownOpen.set(!this.dropdownOpen());
  }

  selectLanguage(langId: string) {
    this.selectedLanguageId.set(langId);
    this.dropdownOpen.set(false); 
  }

  private get profileBasePath(): string {
    return this.router.url.includes('/admin') ? '/admin/profile' : '/user/profile';
  }

  onCancel() {
    this.router.navigate([this.profileBasePath]);
  }

  onSave() {
    if (!this.selectedLanguageId()) return;

    this.loading.set(true);
    console.log('Changing language to:', this.selectedLanguageId());
    
    setTimeout(() => {
      this.loading.set(false);
      // this.languageService.changeLanguage(this.selectedLanguageId()); 
      // window.location.reload(); 
    }, 1500);
  }
}